export default class CustomerGroup3ManagementColumnModel {
	static CustomerGroup3ManagementColumn = [
	  {
		  title: 'Customer group 3',
		  align: 'left',
		  field: 'group3Name'
	  }
	]
}
